import React from 'react';
import { useQuote } from '../../contexts/QuoteContext';
import type { ProductType } from '../../types/quote';

interface Step1ProductTypeProps {
  isActive: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
}

const Step1ProductType: React.FC<Step1ProductTypeProps> = ({ isActive, isCompleted, isDisabled }) => {
  const { quoteState, updateQuoteState, resetSubsequentSteps } = useQuote();

  const handleProductSelect = (product: ProductType) => {
    if (isDisabled) return;

    // If the product is changing, reset all subsequent steps
    if (quoteState.selectedProduct !== product) {
      resetSubsequentSteps(1);
    }

    updateQuoteState({ selectedProduct: product });
  };

  const getStepNumberClass = () => {
    if (isCompleted) return 'completed';
    if (isActive) return 'active';
    return 'disabled';
  };

  return (
    <div className={`step-section ${isActive ? 'active' : isDisabled ? 'disabled' : 'inactive'} ${!isActive && !isCompleted ? 'collapsed' : ''}`}>
      <div className="step-header">
        <div className={`step-number ${getStepNumberClass()}`}>
          <span>1</span>
        </div>
        <h2 className="step-title">Choose Product Type</h2>
      </div>
      {(isActive || isCompleted) && (
        <div className="product-options">
          <div
            className={`product-card ${quoteState.selectedProduct === 'camper' ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
            onClick={() => handleProductSelect('camper')}
            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
          >
            <div className="product-content">
              <img
                src="https://placehold.co/200x200"
                alt="Camper"
                className="product-image"
              />
              <h3 className="product-name">Camper</h3>
              <p className="product-description">Premium off-road campers</p>
            </div>
          </div>
          <div
            className={`product-card ${quoteState.selectedProduct === 'trailer' ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
            onClick={() => handleProductSelect('trailer')}
            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
          >
            <div className="product-content">
              <img
                src="https://placehold.co/200x200"
                alt="Trailer"
                className="product-image"
              />
              <h3 className="product-name">Trailer</h3>
              <p className="product-description">Heavy-duty work trailers</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step1ProductType;
